import { z } from 'zod';

// event sent by Giftcloud
export const ZGiftcloudRewardEvent = z.object({
  EventId: z.string(),
  EventType: z.string(),
  EventTime: z.string(),
  EmailType: z.string().optional(),
  SmsType: z.string().optional(),
  ClientReference: z.string(),
  GiftName: z.string().optional(),
  RecipientEmailAddress: z.string().optional(),
  RecipientPhoneNumber: z.string().optional(),
});
export type TGiftcloudRewardEvent = z.infer<typeof ZGiftcloudRewardEvent>;

export const ZGiftcloudRewardEventNotification = z.object({
  Events: ZGiftcloudRewardEvent.array(),
});
